export const BETA_FEEDBACK_URL = 'https://s66yz.share-na2.hsforms.com/2TFBDfFfmSHqvWWTbqUbRcw'
